import useDocumentTitle from "@/hooks/useDocumentTitle";
import { ArrowLeftIcon, HomeIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export function RouteError404() {
  useDocumentTitle("Error 404");
  const navigate = useNavigate();

  return (
    <div className="flex h-screen w-screen items-center justify-center bg-tertiary text-white">
      <div className="flex max-w-lg flex-col items-center gap-6 rounded-3xl border border-content-highlight bg-content px-12 py-10 text-center shadow-2xl backdrop-blur-md">
        <div className="flex flex-col gap-2">
          <span className="text-6xl font-semibold text-primary">404</span>
          <h1 className="text-2xl font-semibold">Page not found</h1>
          <p className="text-base text-muted-foreground">
            The page you are looking for might have been moved, renamed, or no longer exists.
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4">
          <Button onClick={() => navigate('/patients')} size="lg">
            <HomeIcon className="size-5" />
            Home Page
          </Button>
          <Button variant="outline" onClick={() => navigate(-1)} size="lg">
            <ArrowLeftIcon className="size-5" />
            Back
          </Button>
        </div>
      </div>
    </div>
  );
}
